<template>
  <span>
    <v-autocomplete
      :items="dhbOptions"
      :value="value"
      @input="$emit('input', $event)"
      v-bind="$attrs"
      :clearable="true"
      @click:clear="$emit('input', null)"
    ></v-autocomplete>
  </span>
</template>

<script>
export default {
  name: "pcnzDhbSelect",
  props: {
    value: {
      required:false,
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      dhbOptions: [
        "Northland District Health Board",
        "Auckland District Health Board",
        "Waitemata District Health Board",
        "Counties Manukau District Health Board",
        "Lakes District Health Board",
        "Bay of Plenty District Health Board",
        "Waikato District Health Board",
        "Tairawhiti District Health Board",
        "Hawkes Bay District Health Board",
        "Taranaki District Health Board",
        "Mid Central District Health Board",
        "Whanganui District Health Board",
        "Hutt Valley District Health Board",
        "Capital and Coast District Health Board",
        "Wairarapa District Health Board",
        "Nelson Marlborough District Health Board",
        "Canterbury District Health Board",
        "West Coast District Health Board",
        "South Canterbury District Health Board",        
        "Southern District Health Board",
      ]
    };
  },
  computed: {
    granted() {
      if (!this.permission) {
        return true;
      }
      return this.currentUserCan(this.permission, true);
    },
    adminOverride() {
      return !this.currentUserCan(this.permission, true);
    }
  }
};
</script>
